// import React, { useEffect, useState } from "react";
// import Layout, { Container } from "../components/layout";
// import axios from "axios";
// import { apiurl } from "../config/config";
// import { Bar } from "react-chartjs-2";

// function useQuery() {
//   return new URLSearchParams(window.location.search);
// }

// const Report = () => {
//   const query = useQuery();
//   const [reportData, setReportData] = useState({});
//   const [loading, setLoading] = useState(true);

//   const [startDate, setStartDate] = useState(query.get("startDate") || "");
//   const [endDate, setEndDate] = useState(query.get("endDate") || "");

//   useEffect(() => {
//     const fetchReportData = async () => {
//       try {
//         setLoading(true);
//         const response = await axios.get(
//           `${apiurl}/api/dashboard/summary-dashboard?startDate=${startDate}&endDate=${endDate}`
//         );
//         if (response.data.success) {
//           setReportData(response.data.data);
//         }
//       } catch (error) {
//         console.error("Error fetching report data:", error);
//       } finally {
//         setLoading(false);
//       }
//     };
//     if (startDate && endDate) fetchReportData();
//   }, [startDate, endDate]);

//   if (loading) {
//     return (
//       <Layout>
//         <div className="flex justify-center items-center h-full text-xl font-semibold">
//           Loading Report...
//         </div>
//       </Layout>
//     );
//   }

//   const { total, range } = reportData;

//   return (
//     <Layout>
//       <Container overflow={"overflow-scroll"}>
//         <div className="p-6 space-y-8 bg-[#F9F5F1]">
//           <h2 className="text-2xl font-bold text-[#b4741f]">Detailed Report</h2>

//           {/* Date Filters */}
//           <div className="flex gap-2 mb-6">
//             <input
//               type="date"
//               value={startDate}
//               onChange={(e) => setStartDate(e.target.value)}
//               className="border border-gray-300 rounded-md px-4 py-2"
//             />
//             <input
//               type="date"
//               value={endDate}
//               onChange={(e) => setEndDate(e.target.value)}
//               className="border border-gray-300 rounded-md px-4 py-2"
//             />
//             <button
//               onClick={() =>
//                 (window.location.href = `/report?startDate=${startDate}&endDate=${endDate}`)
//               }
//               className="bg-[#b4741f] text-white px-4 py-2 rounded-md shadow hover:bg-[#915d18] transition"
//             >
//               Refresh
//             </button>
//           </div>

//           {/* === TOTAL SECTION === */}
//           {total && (
//             <div className="space-y-6">
//               <h3 className="text-xl font-bold text-gray-800">Overall Totals</h3>

//               {/* Summary cards */}
//               <div className="grid grid-cols-1 md:grid-cols-4 gap-4">
//                 {["allApplications", "allCandidates", "allEmployees", "allOnTrainees"].map((key) => (
//                   <div key={key} className="bg-white p-5 rounded-xl shadow border text-center">
//                     <h3 className="text-sm font-semibold text-gray-500 uppercase">
//                       {key.replace(/([A-Z])/g, " $1")}
//                     </h3>
//                     <p className="text-xl font-bold text-[#b4741f]">
//                       {total[key].toLocaleString()}
//                     </p>
//                   </div>
//                 ))}
//               </div>

//               {/* Employee Status */}
//               <div className="bg-white p-5 rounded-xl shadow border">
//                 <h4 className="text-lg font-bold text-gray-700 mb-4">
//                   Employee Status
//                 </h4>
//                 <div className="grid grid-cols-2 md:grid-cols-5 gap-4">
//                   {Object.entries(total.employeeStatusCounts).map(([status, count]) => (
//                     <div
//                       key={status}
//                       className="bg-gray-50 p-4 rounded-lg shadow-sm text-center"
//                     >
//                       <h5 className="text-sm font-semibold text-gray-600 capitalize">
//                         {status}
//                       </h5>
//                       <p className="text-lg font-bold text-[#b4741f]">{count}</p>
//                     </div>
//                   ))}
//                 </div>
//               </div>

//               {/* Applications by Status */}
//               <div className="bg-white p-5 rounded-xl shadow border">
//                 <h4 className="text-lg font-bold text-gray-700 mb-4">
//                   Applications by Status
//                 </h4>
//                 <div className="grid grid-cols-2 md:grid-cols-4 gap-4 mb-6">
//                   {Object.entries(total.statusCounts).map(([status, count]) => (
//                     <div
//                       key={status}
//                       className="bg-gray-50 p-4 rounded-lg shadow-sm text-center"
//                     >
//                       <h5 className="text-sm font-semibold text-gray-600 capitalize">
//                         {status}
//                       </h5>
//                       <p className="text-lg font-bold text-[#4f46e5]">{count}</p>
//                     </div>
//                   ))}
//                 </div>

//                 {/* Chart */}
//                 <Bar
//                   data={{
//                     labels: Object.keys(total.statusCounts),
//                     datasets: [
//                       {
//                         label: "Applications",
//                         data: Object.values(total.statusCounts),
//                         backgroundColor: "#4f46e5",
//                       },
//                     ],
//                   }}
//                 />
//               </div>
//             </div>
//           )}

//           {/* === RANGE SECTION === */}
//           {range && (
//             <div className="space-y-6">
//               <h3 className="text-xl font-bold text-gray-800">
//                 Range Report ({range.startDate} → {range.endDate})
//               </h3>

//               <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
//                 <div className="bg-white p-5 rounded-xl shadow border text-center">
//                   <h3 className="text-sm font-semibold text-gray-500 uppercase">
//                     Total Applications
//                   </h3>
//                   <p className="text-xl font-bold text-[#b4741f]">
//                     {range.totalApplications}
//                   </p>
//                 </div>
//                 <div className="bg-white p-5 rounded-xl shadow border text-center">
//                   <h3 className="text-sm font-semibold text-gray-500 uppercase">
//                     New Trainees
//                   </h3>
//                   <p className="text-xl font-bold text-[#b4741f]">
//                     {range.newTrainees}
//                   </p>
//                 </div>
//               </div>

//               {/* Range Status Counts */}
//               <div className="bg-white p-5 rounded-xl shadow border">
//                 <h4 className="text-lg font-bold text-gray-700 mb-4">
//                   Applications by Status (Range)
//                 </h4>
//                 <div className="grid grid-cols-2 md:grid-cols-4 gap-4 mb-6">
//                   {Object.entries(range.statusCounts).map(([status, count]) => (
//                     <div
//                       key={status}
//                       className="bg-gray-50 p-4 rounded-lg shadow-sm text-center"
//                     >
//                       <h5 className="text-sm font-semibold text-gray-600 capitalize">
//                         {status}
//                       </h5>
//                       <p className="text-lg font-bold text-[#16a34a]">{count}</p>
//                     </div>
//                   ))}
//                 </div>

//                 <Bar
//                   data={{
//                     labels: Object.keys(range.statusCounts),
//                     datasets: [
//                       {
//                         label: "Applications",
//                         data: Object.values(range.statusCounts),
//                         backgroundColor: "#16a34a",
//                       },
//                     ],
//                   }}
//                 />
//               </div>
//             </div>
//           )}
//         </div>
//       </Container>
//     </Layout>
//   );
// };

// export default Report;
import React, { useEffect, useState } from "react";
import Layout, { Container } from "../components/layout";
import axios from "axios";
import { apiurl } from "../config/config";
import { Bar } from "react-chartjs-2";
import { Link } from "react-router-dom";
import { FaSearch } from "react-icons/fa";

function useQuery() {
  return new URLSearchParams(window.location.search);
}

const Report = () => {
  const query = useQuery();
  const [reportData, setReportData] = useState({});
  const [loading, setLoading] = useState(true);

  const [startDate, setStartDate] = useState(query.get("startDate") || "");
  const [endDate, setEndDate] = useState(query.get("endDate") || "");
  const [filterStatus, setFilterStatus] = useState([]);

  useEffect(() => {
    const fetchReportData = async () => {
      try {
        setLoading(true);
        const response = await axios.get(
          `${apiurl}/api/dashboard/summary-dashboard?startDate=${startDate}&endDate=${endDate}`
        );
        if (response.data.success) {
          setReportData(response.data.data);
        }
      } catch (error) {
        console.error("Error fetching report data:", error);
      } finally {
        setLoading(false);
      }
    };
    if (startDate && endDate) fetchReportData();
  }, [startDate, endDate]);

  const buildAdvancedSearchLink = () => {
    const params = new URLSearchParams();
    if (filterStatus.length > 0) params.append("applicationStatus", filterStatus.join(","));
    if (startDate) params.append("startDate", startDate);
    if (endDate) params.append("endDate", endDate);

    return params.toString()
      ? `/applications/advanced-search?${params.toString()}`
      : `/applications/advanced-search`;
  };

  if (loading) {
    return (
      <Layout>
        <div className="flex justify-center items-center h-full text-xl font-semibold">
          Loading Report...
        </div>
      </Layout>
    );
  }

  const { total, range } = reportData;

  return (
    <Layout>
      <Container overflow={"overflow-scroll"}>
        <div className="p-6 space-y-8 bg-[#F9F5F1]">
          <h2 className="text-2xl font-bold text-[#b4741f]">Detailed Report</h2>

          {/* Date Filters */}
          <div className="flex gap-2 mb-6">
            <input
              type="date"
              value={startDate}
              onChange={(e) => setStartDate(e.target.value)}
              className="border border-gray-300 rounded-md px-4 py-2"
            />
            <input
              type="date"
              value={endDate}
              onChange={(e) => setEndDate(e.target.value)}
              className="border border-gray-300 rounded-md px-4 py-2"
            />
            <button
              onClick={() =>
                (window.location.href = `/report?startDate=${startDate}&endDate=${endDate}`)
              }
              className="bg-[#b4741f] text-white px-4 py-2 rounded-md shadow hover:bg-[#915d18] transition"
            >
              Refresh
            </button>

            {/* 🔎 Advanced Search Button */}
            <Link
              to={buildAdvancedSearchLink()}
              className="flex items-center gap-2 px-4 py-2 rounded-lg text-white bg-blue-500 hover:bg-blue-600 transition"
            >
              <FaSearch /> Advanced Search
            </Link>
          </div>

          {/* === TOTAL SECTION === */}
          {total && (
            <div className="space-y-6">
              <h3 className="text-xl font-bold text-gray-800">Overall Totals</h3>

              {/* Summary cards */}
              <div className="grid grid-cols-1 md:grid-cols-4 gap-4">
                {["allApplications", "allCandidates", "allEmployees", "allOnTrainees"].map((key) => (
                  <div key={key} className="bg-white p-5 rounded-xl shadow border text-center">
                    <h3 className="text-sm font-semibold text-gray-500 uppercase">
                      {key.replace(/([A-Z])/g, " $1")}
                    </h3>
                    <p className="text-xl font-bold text-[#b4741f]">
                      {total[key].toLocaleString()}
                    </p>
                  </div>
                ))}
              </div>

              {/* Applications by Status */}
              <div className="bg-white p-5 rounded-xl shadow border">
                <h4 className="text-lg font-bold text-gray-700 mb-4">
                  Applications by Status
                </h4>
                <div className="grid grid-cols-2 md:grid-cols-4 gap-4 mb-6">
                  {Object.entries(total.statusCounts).map(([status, count]) => (
                    <Link
                      key={status}
                      to={`/applications/advanced-search?applicationStatus=${status}&startDate=${startDate}&endDate=${endDate}`}
                      title={`Click to view all ${status.charAt(0).toUpperCase() + status.slice(1)} Applications`}
                      className="bg-gray-50 p-4 rounded-lg shadow-sm text-center hover:shadow-md transition cursor-pointer"
                    >
                      <h5 className="text-sm font-semibold text-gray-600 capitalize">
                        {status}
                      </h5>
                      <p className="text-lg font-bold text-[#4f46e5]">{count}</p>
                    </Link>
                  ))}
                </div>

                {/* Chart */}
                <Bar
                  data={{
                    labels: Object.keys(total.statusCounts),
                    datasets: [
                      {
                        label: "Applications",
                        data: Object.values(total.statusCounts),
                        backgroundColor: "#4f46e5",
                      },
                    ],
                  }}
                />
              </div>
            </div>
          )}

          {/* === RANGE SECTION === */}
          {range && (
            <div className="space-y-6">
              <h3 className="text-xl font-bold text-gray-800">
                Range Report ({range.startDate} → {range.endDate})
              </h3>

              {/* Range Status Counts */}
              <div className="bg-white p-5 rounded-xl shadow border">
                <h4 className="text-lg font-bold text-gray-700 mb-4">
                  Applications by Status (Range)
                </h4>
                <div className="grid grid-cols-2 md:grid-cols-4 gap-4 mb-6">
                  {Object.entries(range.statusCounts).map(([status, count]) => (
                    <Link
                      key={status}
                      to={`/applications/advanced-search?applicationStatus=${status}&startDate=${startDate}&endDate=${endDate}`}
                      title={`Click to view all ${status.charAt(0).toUpperCase() + status.slice(1)} Applications`}
                      className="bg-gray-50 p-4 rounded-lg shadow-sm text-center hover:shadow-md transition cursor-pointer"
                    >
                      <h5 className="text-sm font-semibold text-gray-600 capitalize">
                        {status}
                      </h5>
                      <p className="text-lg font-bold text-[#16a34a]">{count}</p>
                    </Link>
                  ))}
                </div>

                <Bar
                  data={{
                    labels: Object.keys(range.statusCounts),
                    datasets: [
                      {
                        label: "Applications",
                        data: Object.values(range.statusCounts),
                        backgroundColor: "#16a34a",
                      },
                    ],
                  }}
                />
              </div>
            </div>
          )}
        </div>
      </Container>
    </Layout>
  );
};

export default Report;
